import { VOTING_STATUS_ENUM, VOTING_TYPE_ENUM, VOTING_SCOPE_ENUM } from "@antipartido-inc/contracts-ifaces"

export default {
  table: {
    title: "Título",
    status: "Estado",
    type: "Tipo",
    participants: "Votos",
    period: "Periodo",
    actions: "Acciones",
    searchPlaceholder: "Buscar votaciones...",
    empty: "No se encontraron votaciones",
    errorRetry: "Reintentar",
  },
  featured: {
    title: "Votación fija",
    votes: "votos",
  },
  actions: {
    create: "Crear",
    edit: "Editar",
    view: "Ver",
    delete: "Eliminar",
    publish: "Publicar",
    setToActive: "Activar",
  },
  status: {
    [VOTING_STATUS_ENUM.DRAFT]: "Borrador",
    [VOTING_STATUS_ENUM.UPCOMING]: "Próxima",
    [VOTING_STATUS_ENUM.ACTIVE]: "Activa",
    [VOTING_STATUS_ENUM.CLOSED]: "Cerrada",
  },
  type: {
    [VOTING_TYPE_ENUM.PROPOSAL]: "Propuesta",
    [VOTING_TYPE_ENUM.CANDIDATE]: "Candidatura",
  },
  scope: {
    [VOTING_SCOPE_ENUM.GLOBAL]: "Global",
    [VOTING_SCOPE_ENUM.LOCAL_ENTIDAD]: "Local - Entidad",
    [VOTING_SCOPE_ENUM.LOCAL_DISTRITO]: "Local - Distrito",
    [VOTING_SCOPE_ENUM.LOCAL_MUNICIPIO]: "Local - Municipio",
    [VOTING_SCOPE_ENUM.LOCAL_SECCION]: "Local - Sección",
  },
  errors: {
    theFilesAreTooLarge: "Los archivos son demasiado grandes. El tamaño máximo por archivo es de 10 MB.",
    docsTitleRequired: "Todos los documentos deben tener un título.",
  },
  create: {
    title: "Crear Votación",
    success: "Votación creada correctamente",
    errors: {
      saveFailed: "Error al crear la votación",
      unknown: "Ha ocurrido un error inesperado. Inténtalo de nuevo.",
    },
  },
  view: {
    title: "Detalle de Votación",
  },
  edit: {
    title: "Editar Votación",
    success: "Votación guardada correctamente",
    deleteTitle: "Eliminar votación",
    deleteConfirm: "¿Estás seguro de que quieres eliminar esta votación?",
    publishConfirm: "¿Estás seguro de que quieres publicar esta votación?",
    publishConfirmWithSave: "Se guardarán los cambios pendientes y se publicará la votación. ¿Deseas continuar?",
    errors: {
      loadFailed: "Error al cargar la votación",
      saveFailed: "Error al guardar la votación",
      deleteFailed: "Error al eliminar la votación",
      publishFailed: "Error al publicar la votación",
      statusChangeFailed: "Error al cambiar el estado",
      updatePublishedFailed: "Error al actualizar la votación publicada",
      setVoteWindowFailed: "Error al actualizar las fechas de la votación",
      setVoteWindowAlreadyPending:
        "Ya hay una transacción pendiente para actualizar las fechas. Por favor, fírmala en Safe antes de realizar nuevos cambios.",
      publishSafeProposalInProgress:
        "Ya hay una propuesta de Safe en curso para esta votación. Por favor, espera a que se complete antes de publicar de nuevo.",
      toggleAutoUpdateFailed: "Error al cambiar el estado de actualización automática.",
      unknown: "Ha ocurrido un error inesperado. Inténtalo de nuevo.",
    },
    pendingSafeApproval: {
      title: "Pendiente de aprobación",
      description:
        "El proceso de creación del token está a la espera de aprobación en Safe. Por favor, firma la transacción en Safe para continuar.",
    },
    pendingVoteWindowApproval: {
      title: "Cambio de fechas pendiente de aprobación",
      description:
        "Hay una transacción pendiente para actualizar las fechas de la votación. Por favor, firma la transacción en Safe para aplicar los cambios.",
    },
    validation: {
      required: "Este campo es obligatorio",
      maxLength: "Máximo {{max}} caracteres ({{current}} actualmente)",
      publishRequirements: "Para publicar la votación debe tener un título, una descripción y al menos 2 opciones.",
      saveRequirements: "Para guardar la votación debe tener al menos un título y una descripción.",
      range: "Debe ser entre {{min}} y {{max}}",
      minValue: "Debe ser mayor o igual a {{min}}",
    },
    fields: {
      title: "Título",
      description: "Descripción",
      status: "Estado",
      type: "Tipo",
      scope: "Ámbito",
      visibility: "Visibilidad",
      startDate: "Inicio",
      endDate: "Fin",
      participants: "Votos",
      tokenName: "Nombre del token",
      tokenSymbol: "Símbolo del token",
      tokenAddress: "Dirección del token",
      territorialTarget: "Objetivo Territorial",
      entidadClave: "Entidad",
      distritoClave: "Distrito",
      municipioClave: "Municipio",
      seccion: "Sección",
      selectPlaceholder: "Seleccionar...",
    },
    savePublished: "Guardar cambios",
    autoUpdate: {
      title: "Actualización automática de censo",
      description: "Cuando está activado, el censo de esta votación se actualizará automáticamente.",
      enable: "Activar",
      disable: "Desactivar",
    },
    voteWindow: {
      button: "Cambiar fechas",
      modalTitle: "Cambiar fechas de votación",
      warning:
        "Esta acción generará una transacción en blockchain. Asegúrate de que las fechas son correctas antes de confirmar.",
      confirm: "Confirmar",
    },
    sections: {
      general: "General",
      config: "Configuración",
      token: "Información del Token",
      tokenButton: "Configuración del Token",
      tokenInfo:
        "Los campos del token se generan automáticamente. No es necesario modificarlos salvo que tengas una necesidad específica.",
      options: "Opciones de Votación",
      documents: "Documentos",
      scope: "Ámbito Territorial",
    },
    documents: {
      add: "Añadir Documento",
      empty: "No hay documentos",
      fields: {
        name: "Nombre",
        title: "Título",
      },
    },
    options: {
      empty: "No hay opciones. Añade al menos 2 para poder publicar.",
      add: "Añadir Opción",
      addTitle: "Añadir Nueva Opción",
      editTitle: "Editar Opción",
      fields: {
        title: "Título",
        description: "Descripción",
        key: "Clave",
        votes: "Votos",
        percentage: "Porcentaje",
        sinkAddress: "Dirección destino",
        candidateImage: "Imagen del candidato",
        documentFallback: "Documento",
      },
      candidateImage: {
        add: "Añadir imagen",
        change: "Cambiar imagen",
        empty: "No hay imagen de candidato",
      },
    },
  },
  saveSuccess: {
    title: "Votación guardada",
    message: "La votación se ha guardado correctamente.",
    messageWithPublish: "La votación se ha guardado correctamente. Puedes publicarla ahora.",
    continueEditing: "Seguir editando",
    goToList: "Ir al listado",
  },
  safeProposal: {
    title: "Votación Creada",
    description: "La votación se ha creado correctamente. En unos minutos estará publicada y disponible.",
    openInSafe: "Abrir en Safe",
    fields: {
      status: "Estado",
      safeTxHash: "Hash de Transacción",
      safeAddress: "Dirección del Safe",
      chainId: "Chain ID",
      nonce: "Nonce",
      threshold: "Umbral",
      signatures: "Firmas",
      proposedBy: "Propuesto por",
    },
  },
}
